import React from "react";
import {
    Calendar,
    ChevronRight,
    Utensils,
    Plus,
    Table as TableIcon,
    Search,
    Layout
} from 'lucide-react';
import { useTheme } from '../guardarToken/themeContext';
import DatePicker from '../DatePicker';
import BotonAcceso from '../elementos/BotonAcceso';

function Carga() {
    const { isDarkMode } = useTheme();

    return (
        <div className={`min-h-screen p-3 lg:p-4 font-sans transition-colors duration-300 ${isDarkMode ? "bg-slate-950 text-white" : "bg-slate-50 text-slate-800"}`}>

            {/* HEADER PREMIUM */}
            <div className={`${isDarkMode ? "bg-slate-900 border-slate-800" : "bg-white border-slate-200"} rounded-2xl shadow-sm p-5 mb-6 flex flex-col md:flex-row items-center justify-between border ring-1 ring-black/5 animate-in slide-in-from-top duration-700`}>
                <div className="flex items-center gap-4">
                    <div className="bg-gradient-to-br from-orange-500 to-orange-700 p-3 rounded-xl shadow-lg shadow-orange-900/20">
                        <Plus className="text-white w-6 h-6" />
                    </div>
                    <div>
                        <h1 className="text-xl font-black tracking-tight leading-none mb-1">Carga Diaria</h1>
                        <p className={`text-[11px] ${isDarkMode ? "text-slate-400" : "text-slate-500"} font-black uppercase tracking-wider`}>Asignación rápida de menús por fecha</p>
                    </div>
                </div>

                <div className="flex items-center gap-3 mt-4 md:mt-0">
                    <BotonAcceso
                        variant="accent"
                        className="bg-orange-600 hover:bg-orange-700 text-white font-black text-[11px] uppercase tracking-widest px-6 py-2.5 rounded-xl shadow-lg shadow-orange-950/20 flex items-center gap-2 transform hover:scale-[1.02] transition-all"
                    >
                        Guardar Menú <ChevronRight className="w-4 h-4" />
                    </BotonAcceso>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

                {/* FORM PANEL */}
                <div className={`${isDarkMode ? "bg-slate-900 border-slate-800 shadow-xl" : "bg-white border-slate-200 shadow-sm"} rounded-3xl p-8 border animate-in slide-in-from-left duration-1000`}>
                    <div className="flex items-center gap-3 mb-8">
                        <Calendar className="w-5 h-5 text-orange-500" />
                        <h2 className="text-sm font-black uppercase tracking-widest">Configurar Día</h2>
                    </div>

                    <div className="space-y-8">
                        {/* SELECT DATE */}
                        <div className="space-y-2">
                            <label className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-500 ml-1">Fecha de Aplicación</label>
                            <div className={`p-1 rounded-2xl border ${isDarkMode ? "bg-slate-950 border-slate-800" : "bg-slate-50 border-slate-100"}`}>
                                <DatePicker />
                            </div>
                        </div>

                        {/* MENU SELECTIONS */}
                        <div className="space-y-6">
                            <div className="space-y-2">
                                <label className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-500 ml-1">Menú General</label>
                                <select className={`w-full px-4 py-3.5 rounded-2xl text-[11px] font-black uppercase tracking-widest focus:outline-none transition-all ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"
                                    } border ring-2 ring-orange-500/0 focus:ring-orange-500/10`}>
                                    <option>Seleccionar Plato...</option>
                                    <option>Menú general</option>
                                </select>
                            </div>

                            <div className="space-y-2">
                                <label className="text-[10px] font-black uppercase tracking-[0.2em] text-emerald-500/60 ml-1">Menú Vegetariano</label>
                                <select className={`w-full px-4 py-3.5 rounded-2xl text-[11px] font-black uppercase tracking-widest focus:outline-none transition-all ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"
                                    } border ring-2 ring-emerald-500/0 focus:ring-emerald-500/10`}>
                                    <option>Seleccionar Plato...</option>
                                    <option>Menú Vegetariano</option>
                                </select>
                            </div>

                            <div className="space-y-2">
                                <label className="text-[10px] font-black uppercase tracking-[0.2em] text-indigo-500/60 ml-1">Menú Light</label>
                                <select className={`w-full px-4 py-3.5 rounded-2xl text-[11px] font-black uppercase tracking-widest focus:outline-none transition-all ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"
                                    } border ring-2 ring-indigo-500/0 focus:ring-indigo-500/10`}>
                                    <option>Seleccionar Plato...</option>
                                    <option>Menú Light</option>
                                </select>
                            </div>
                        </div>

                        <div className={`p-4 rounded-2xl flex items-start gap-4 ${isDarkMode ? "bg-amber-500/5 border border-amber-500/10" : "bg-amber-50 border border-amber-100"}`}>
                            <div className="bg-amber-500 p-2 rounded-lg">
                                <Utensils className="w-4 h-4 text-white" />
                            </div>
                            <p className="text-[10px] font-bold leading-relaxed text-amber-600/80">
                                La carga diaria permite configurar rápidamente los platos para una fecha específica sin necesidad de usar el grid semanal completo.
                            </p>
                        </div>
                    </div>
                </div>

                {/* VISUALIZATION / LOG PANEL */}
                <div className="space-y-6 animate-in slide-in-from-bottom duration-1000">
                    <div className={`${isDarkMode ? "bg-slate-900 border-slate-800" : "bg-white border-slate-200"} rounded-3xl p-8 border shadow-sm min-h-[400px] flex flex-col`}>
                        <div className="flex items-center justify-between mb-8 pb-4 border-b border-slate-800/50">
                            <div className="flex items-center gap-3">
                                <TableIcon className="w-5 h-5 text-indigo-500" />
                                <h3 className="text-sm font-black uppercase tracking-widest">Vista Previa</h3>
                            </div>
                            <div className="flex items-center gap-2 px-3 py-1 rounded-full bg-slate-800/50 border border-slate-700">
                                <Search className="w-3 h-3 text-slate-500" />
                                <span className="text-[9px] font-black uppercase text-slate-500">Filtrar</span>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col items-center justify-center text-center opacity-40 grayscale group">
                            <div className="w-16 h-16 rounded-3xl bg-slate-800 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-500">
                                <Layout className="w-8 h-8 text-slate-600" />
                            </div>
                            <p className="text-[10px] font-black uppercase tracking-widest text-slate-500 max-w-[200px]">Selecciona una fecha para visualizar el menú cargado actualmente</p>
                        </div>
                    </div>

                    <div className={`${isDarkMode ? "bg-indigo-500/5 border-indigo-500/10" : "bg-indigo-50 border-indigo-100"} rounded-3xl p-6 border flex items-center justify-between`}>
                        <div className="space-y-1">
                            <h4 className="text-[10px] font-black uppercase tracking-widest text-indigo-400 leading-none">Carga Recomendada</h4>
                            <p className={`text-[11px] font-bold ${isDarkMode ? "text-slate-400" : "text-slate-600"}`}>Utiliza el Cargador Semanal para mayor eficiencia.</p>
                        </div>
                        <BotonAcceso className="bg-indigo-500/10 text-indigo-400 text-[9px] font-black uppercase tracking-widest px-4 py-2 rounded-xl border border-indigo-500/20 hover:bg-indigo-500 transition-colors hover:text-white">
                            Ir a Semanal
                        </BotonAcceso>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Carga;